import React, { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import SLUGS from '../resources/slugs';
import LoadingComponent from '../components/loading';

import MyProfile from '../components/employees/MyProfile';
import Addcandidate from '../components/candidates/Addcandidate';
import Total from '../components/candidates/Total';
import JobOpenings from '../components/candidates/JobOpenings';
import JobApplications from '../components/candidates/JobApplications';

import ScheduledCandidate from '../components/candidates/ScheduledCandidate';
import RejectedCandidate from '../components/candidates/RejectedCandidate';
import SelectedCandidate from '../components/candidates/SelectedCandidate';
import ProgressCand from '../components/candidates/ProgressCand';
import Employees from '../components/employees/Employees';

import CreateNewEmp from '../components/employees/CreateNewEmp';
import OnboardingDashboard from '../components/employees/OnboardingDashboard';
import Salary from '../components/employees/Salary';
import SalaryEmp from '../components/payroll/SalaryEmp';
import PayrollProcess from '../components/payroll/PayrollProcess';
import Payslip from '../components/payroll/Payslip';
import Leaves from '../components/employees/Leaves';
import TeamLeaves from '../components/employeeUI/Leaves/TeamLeaves';
import Empxcel from '../components/employees/Empxcel';
import Paylogs from '../components/payroll/Paylogs';
import ResignedEmp from '../components/employees/ResignedEmp';
import EmpDocument from '../components/employees/EmpDocument';
import WhatsAppDashboard from '../components/WhatsappDashboard';
import EmployeesWithoutSalary from '../components/employees/EmployeesWithoutSalary';
import BulkSalaryUpdate from '../components/payroll/BulkSalaryUpdate';
import DetailedSalaryReport from '../components/payroll/DetailedSalaryReport';
import MasterData from '../components/employees/MasterData';
import Contacts from '../components/employees/Contacts';
import LeaveTracker from './dashboard/LeaveTracker';
import AttendancePresent from '../components/Attendance/AttendancePresent';
import ShiftManagementPage from '../components/Attendance/ShiftManagement/ShiftManagementPage';
import BiometricMain from '../components/Attendance/Biometric/BiometricMain';



import DashboardComponent from './dashboard';
import DashboardDemo from './dashboard/DashboardDemo';
import RoleManagement from '../components/employees/RoleManagement';
import Form16ListAdmin from '../components/payroll/Form16/Form16ListAdmin';
import Form16Detail from '../components/payroll/Form16/Form16Detail';
import DeclarationsAdminReview from '../components/payroll/Form16/DeclarationsAdminReview';
import RectificationsAdmin from '../components/payroll/Form16/RectificationsAdmin';
import EmployerSetup from '../components/payroll/Form16/EmployerSetup';
import TaxCalculatorAdmin from '../components/payroll/TaxCalculator/TaxCalculatorAdmin';
import ActivityLogs from '../components/employees/ActivityLogs';
import CompanySettingsTab from '../components/employees/CompanySettingsTab';
import OrganizationChart from '../components/org/OrganizationChart';
import { AuthContext } from '../context/logeduser';

const ProtectedRoute = ({ element, module, action = 'view' }) => {
  const { authData } = React.useContext(AuthContext);
  const isRestricted = authData?.admin?.is_restricted;
  
  if (!isRestricted) return element; // Full Admin has everything

  const hasAccess = authData?.admin?.permissions?.[module]?.[action];
  return hasAccess ? element : <Navigate to={SLUGS.dashboard} />;
};

const GlobalAdminRoute = ({ element }) => {
  const { authData } = React.useContext(AuthContext);
  const admin = authData?.admin;
  const isGlobalAdmin = !admin?.is_restricted && admin?.email === 'admin@atshub.in';
  return isGlobalAdmin ? element : <Navigate to={SLUGS.dashboard} />;
};

function PrivateRoutes() {
  return (
    <Suspense fallback={<LoadingComponent loading />}>
      <Routes>
        <Route path={SLUGS.dashboard} element={<ProtectedRoute module="dashboard" element={<DashboardComponent />} />} />
        <Route path="/dashboard-demo" element={<DashboardDemo />} />
        
        {/* Recruitment Routes */}
        <Route path={SLUGS.sheduled} element={<ProtectedRoute module="recruitment" element={<ScheduledCandidate />} />} />
        <Route path={SLUGS.candidate} element={<ProtectedRoute module="recruitment" action="edit" element={<Addcandidate />} />} />
        <Route path={SLUGS.totalcandidate} element={<ProtectedRoute module="recruitment" element={<Total />} />} />
        <Route path={SLUGS.jobOpenings} element={<ProtectedRoute module="recruitment" action="edit" element={<JobOpenings />} />} />
        <Route path={SLUGS.jobApplications} element={<ProtectedRoute module="recruitment" action="edit" element={<JobApplications />} />} />
        <Route path={SLUGS.rejected} element={<ProtectedRoute module="recruitment" element={<RejectedCandidate />} />} />
        <Route path={SLUGS.selected} element={<ProtectedRoute module="recruitment" element={<SelectedCandidate />} />} />
        <Route path={SLUGS.progress} element={<ProtectedRoute module="recruitment" element={<ProgressCand />} />} />

        {/* Employee Management Routes */}
        <Route path={SLUGS.employees} element={<ProtectedRoute module="employees" element={<Employees />} />} />
        <Route path={SLUGS.createemp} element={<ProtectedRoute module="employees" action="edit" element={<CreateNewEmp />} />} />
        <Route path={SLUGS.onboarding} element={<ProtectedRoute module="employees" element={<OnboardingDashboard />} />} />
        <Route path='/uploaddata' element={<ProtectedRoute module="employees" action="edit" element={<Empxcel />} />} />
        <Route path='/resigned/employees' element={<ProtectedRoute module="employees" element={<ResignedEmp />} />} />
        <Route path='/uploademployee/docs' element={<ProtectedRoute module="employees" element={<EmpDocument />} />} />
        <Route path={SLUGS.employeesWithoutSalary} element={<ProtectedRoute module="employees" element={<EmployeesWithoutSalary />} />} />

        {/* Contacts — company phone directory. The sidebar "Contacts" item (under
            PEOPLE) is intentionally ungated for all users, so the route is left
            ungated too — gating it by a module would bounce restricted admins who
            can see the menu item straight back to the dashboard (the very redirect
            this route fixes). Must sit above the "*" catch-all. */}
        <Route path={SLUGS.contacts} element={<Contacts />} />

        {/* Payroll Routes */}
        <Route path={SLUGS.payroll} element={<ProtectedRoute module="payroll" element={<SalaryEmp />} />} />
        <Route path={SLUGS.payrollProcess} element={<ProtectedRoute module="payroll" action="edit" element={<PayrollProcess />} />} />
        <Route path={SLUGS.payrollSlip} element={<ProtectedRoute module="payroll" element={<Payslip />} />} />
        <Route path={SLUGS.bulkSalary} element={<ProtectedRoute module="payroll" action="edit" element={<BulkSalaryUpdate />} />} />
        <Route path={SLUGS.payslipLogs} element={<ProtectedRoute module="payroll" element={<Paylogs />} />} />
        <Route path={SLUGS.detailedSalaryReport} element={<ProtectedRoute module="payroll" element={<DetailedSalaryReport />} />} />
        <Route path='/salary/breakdown/:empid' element={<ProtectedRoute module="employees" element={<Salary />} />} />

        {/* Tax Calculator */}
        <Route path={SLUGS.taxCalculator} element={<TaxCalculatorAdmin />} />

        {/* Form 16 Routes */}
        <Route path={SLUGS.payrollForm16} element={<ProtectedRoute module="payroll" element={<Form16ListAdmin />} />} />
        <Route path={SLUGS.payrollDeclarationsAdmin} element={<ProtectedRoute module="payroll" element={<DeclarationsAdminReview />} />} />
        <Route path={SLUGS.payrollRectifications} element={<ProtectedRoute module="payroll" element={<RectificationsAdmin />} />} />
        <Route path={SLUGS.payrollEmployerSetup} element={<ProtectedRoute module="payroll" action="edit" element={<EmployerSetup />} />} />
        <Route path={SLUGS.payrollForm16Detail} element={<ProtectedRoute module="payroll" element={<Form16Detail />} />} />

        {/* Attendance & Leaves */}
        <Route path={SLUGS.leaves} element={<ProtectedRoute module="leaves" element={<Leaves />} />} />
        <Route path={SLUGS.attendancePresent} element={<ProtectedRoute module="leaves" element={<AttendancePresent />} />} />
        <Route path={SLUGS.shiftManagement} element={<ProtectedRoute module="leaves" action="edit" element={<ShiftManagementPage />} />} />
        <Route path={SLUGS.biometricManagement} element={<ProtectedRoute module="leaves" action="edit" element={<BiometricMain />} />} />
        <Route path="/team-leaves" element={<ProtectedRoute module="leaves" element={<TeamLeaves />} />} />
        <Route path={SLUGS.leaveTracker} element={<ProtectedRoute module="leaves" element={<LeaveTracker />} />} />

        {/* Master Data & Settings */}
        <Route path="/master-data" element={<ProtectedRoute module="master_records" element={<MasterData />} />} />
        <Route path={SLUGS.organizationChart} element={<ProtectedRoute module="master_records" element={<OrganizationChart />} />} />
        <Route path={SLUGS.userRoleMgmt} element={<ProtectedRoute module="settings" element={<RoleManagement />} />} />
        <Route path={SLUGS.companyProfile} element={<ProtectedRoute module="settings" action="edit" element={<CompanySettingsTab />} />} />
        <Route path={SLUGS.activityLogs} element={<GlobalAdminRoute element={<ActivityLogs />} />} />
        <Route path="/settings" element={<ProtectedRoute module="settings" element={<MyProfile />} />} />
        <Route path="/whatsapp-dashboard" element={<ProtectedRoute module="recruitment" element={<WhatsAppDashboard />} />} />

        <Route path="*" element={<Navigate to={SLUGS.dashboard} />} />
      </Routes>
    </Suspense>
  );
}

export default PrivateRoutes;
